"use strict";

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className", "randomWidth", "blinking", "backgroundColour", "display", "is"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Box } from "../Box/index.js";
import * as styles from "./LoadingBox.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingBox = _ref => {
  let {
      className = '',
      randomWidth = false,
      blinking = true,
      backgroundColour = 'gray200',
      display = 'block',
      is = 'span'
    } = _ref,
    boxStyles = _objectWithoutProperties(_ref, _excluded);
  return _jsx(Box, _objectSpread(_objectSpread({
    is: is,
    display: display,
    width: randomWidth ? undefined : 'full',
    backgroundColour: backgroundColour
  }, boxStyles), {}, {
    className: [styles.root, blinking && styles.blinking, className],
    style: {
      width: randomWidth ? getRandomIntWidth(60, 40) : undefined
    }
  }));
};
const getRandomIntWidth = (max, min) => `${Math.random() * (max - min) + min}%`;
export default LoadingBox;